module.exports = __webpack_public_path__ + "static/media/iconfont.01e57003.svg";